module.exports = __webpack_public_path__ + "img/zhxy_image_3.4b5c8ac3.png";